import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import { Button, Grid } from '@mui/material';
import '../common/Styles.css'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#fff',
    border: '1px solid #BDE0FF',
    borderRadius: '28px',
    boxShadow: '0px 4px 20px 0px #E3F0FC',
    p: 4,
    textAlign: 'center',
};

/**
 * Confirm Modal
 * @param {*} props 
 * @returns 
 */
export default function ConfirmModal(props) {
    const [open, setOpen] = React.useState(props['open'] ?? false);
    //   const handleOpen = () => setOpen(true);
    //   const handleClose = () => setOpen(false);

    const [modalHeading, setModalHeading] = React.useState(props['headingLabel'] ?? 'Are you Sure?')
    const [modalMessage, setModalMessage] = React.useState(props['message'] ?? '')
    const [continueBtnLabel, setContinueBtnLabel] = React.useState(props['continueBtnLabel'] ?? 'Yes')
    const [cancelBtnLabel, setCancelBtnLabel] = React.useState(props['cancelBtnLabel'] ?? 'Cancel')

    const onCancelClick = () => {
        setOpen(false)
        props['onActionTaken'](false)
    }

    const onContinueClick = () => {
        setOpen(false)
        props['onActionTaken'](true)
    }

    return (
        <div>
            <Modal
                className='confirm-modal'
                keepMounted
                open={open}
                onClose={onCancelClick}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: 'rgba(0, 0, 0, 0.65)',
                        },
                    },
                }}
            >
                <Box sx={style}>
                    <Typography id="keep-mounted-modal-title" variant="h4" color={'#012A4A'}>{modalHeading}</Typography>
                    <div id="keep-mounted-modal-description" className='content-wrapper'>
                        {modalMessage}
                    </div>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <Button
                                variant='outlined'
                                onClick={() => onCancelClick()}
                                className='modal-back-btn'
                            >{cancelBtnLabel}</Button>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Button
                                variant='contained'
                                onClick={() => onContinueClick()}
                                className='modal-continue-btn'
                            >{continueBtnLabel}</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}